import React from 'react';
import { AppBarTitle } from '@components/app-bar-title';
import { IconButton } from '@material-ui/core';
import SpellcheckRoundedIcon from '@material-ui/icons/SpellcheckRounded';
import { useHistory } from 'react-router-dom';
import AddC3Relation from '../add';

export default function C3PageCreate() {
  const history = useHistory();

  return (
    <>
      <AppBarTitle>
        <IconButton color="inherit">
          <SpellcheckRoundedIcon color="secondary" height="2em" width="2em" />
        </IconButton>{' '}
        Create New C3 Page Entry
      </AppBarTitle>
      <AddC3Relation />
    </>
  );
} 